import axios from 'axios'
import { get } from 'lodash'
import { getFromLocal } from '@/utils'

export default class RestClient {
  static get apiUrl () {
    return process.env.VUE_APP_API_URL
  }

  static get tenantId () {
    return process.env.VUE_APP_TENANT_ID
  }

  static get url () {
    throw new Error('Pending Implementation!')
  }

  static get paramKey () {
    throw new Error('Pending Implementation!')
  }

  static get http () {
    return axios
  }

  static get accessToken () {
    const key = `hydra-ship-v-${String(process.env.VUE_APP_COMPANY).snakeCase()}-${process.env.NODE_ENV[0]}`
    const user = getFromLocal(key) || {}

    return user.token
  }

  static get email () {
    const key = `hydra-ship-v-${String(process.env.VUE_APP_COMPANY).snakeCase()}-${process.env.NODE_ENV[0]}`
    const user = getFromLocal(key) || {}

    return user.email
  }

  static get headers () {
    return {
      Authorization: `Token token=${this.accessToken};company=${ btoa(process.env.VUE_APP_COMPANY) };email=${this.email}`,
      'Access-Control-Allow-Headers': '*',
      'Access-Control-Allow-Origin': '*'
    }
  }

  static async all (filter) {
    const { data } = await this._get(this.url, filter)

    if (!data.data) {
      const collection = new Array()
      collection.pagination = get(data, 'meta.pagination') || {}
      return collection
    }

    if (Array.isArray(data.data)) {
      const collection = new Array(...data.data.map(o => new this(o)))
      collection.pagination = get(data, 'meta.pagination') || {}
      return collection
    } else {
      return new this(data.data)
    }
  }

  static async create (payload) {
    let params = {}
    if (this.paramKey) {
      params[this.paramKey] = payload
    } else {
      params = payload
    }

    const { data } = await this._post(this.url, params)

    return new this(data.data)
  }

  static async findOne (id, filter = {}) {
    const { data } = await this._get(this.url + `/${id}`, filter)

    return new this(data.data)
  }

  static async count (where = {}) {
    const { data } = await this._get(this.url + '/count', { where })

    return new this(data.data)
  }

  static async destroyById (id) {
    const { data } = await this._delete(`${this.url}/${id}`)

    return new this(data.data)
  }

  static async _get (url, params) {
    return this.http.get(url, {
      params,
      headers: this.headers
    })
  }

  static async _post (url, params) {
    return this.http.post(url, params, {
      headers: this.headers
    })
  }

  static async _patch (url, params) {
    return this.http.patch(url, params, {
      headers: this.headers
    })
  }

  static async _put (url, params) {
    return this.http.put(url, params, {
      headers: this.headers
    })
  }

  static async _delete (url) {
    return this.http.delete(url, {
      headers: this.headers
    })
  }

  // Prototype -------------------------------------------------------------------------------------

  constructor (attrs = {}) {
    this._setAttributes(attrs)
  }

  _setAttributes (attrs) {
    if (!attrs) { return }

    Object.keys(attrs).forEach(key => {
      this[key] = attrs[key]
      Object.defineProperty(this, key, {
        value: attrs[key],
        enumerable: true,
        writable: true
      })
    })
  }

  async save (returnData = false) {
    if (this.id) {
      return this.update()
    } else {
      return this.create(returnData)
    }
  }

  async create (returnData = false) {
    let payload = {}
    if (this.paramKey) {
      payload = { ...this }
    } else {
      payload[this.constructor.paramKey] = { ...this }
    }
    const { data } = await this.constructor._post(this.constructor.url, payload)
    this._setAttributes(data.data)

    if (returnData) { return data.data }

    return true
  }

  async update () {
    let payload = {}
    if (this.paramKey) {
      payload = { ...this }
    } else {
      payload[this.constructor.paramKey] = { ...this }
    }
    const { data } = await this.constructor._put(this.constructor.url + `/${this.id}`, payload)
    this._setAttributes(data.data)

    return true
  }
}
